import PicklistHandler from '~/services/filter-form-service/FilterHandlers/PicklistHandler';
import MultiselectHandler from '~/services/filter-form-service/FilterHandlers/MultiselectHandler';

export default class FormsBuilder {
  constructor() {
    this.setOverrides();
    this.formsFieldTypeHandlers = [new PicklistHandler(this.overrides), new MultiselectHandler(this.overrides)];
  }

  setOverrides() {
    this.overrides = [];
  }

  findHandler(property) {
    return this.formsFieldTypeHandlers.find((handler) => handler.canHandle(property));
  }

  buildForm(properties) {
    return this.createFormsFields(properties);
  }

  createFormsFields(filterProperties) {
    const formsFields = filterProperties.map((property) => this.createFormsField(property));
    return formsFields;
  }

  createFormsField(property) {
    const fieldHandler = this.findHandler(property);
    return fieldHandler.handleField(property);
  }
}
